/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_NewInputs */

const vi_status_order_new = /** @type {(inputs: Status_Order_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mới`)
};

/**

* @param {Status_Order_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_new = /** @type {((inputs?: Status_Order_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_new(inputs)
});